import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="text-center py-32" data-testid="page-not-found">
      <SEO title="Page not found" noindex />
      <h1 className="font-serif text-3xl">Page not found</h1>
      <p className="text-sm text-muted-foreground mt-3">The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
      <Link to="/shop" className="small-caps text-gold border-b border-gold mt-4 inline-block" data-testid="not-found-back-to-shop">Back to Shop</Link>
    </div>
  );
}
